import React from 'react';
import { CheckCircle, Clock, ShieldCheck, Award } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

export function TrustStrip() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const items = [
    { icon: <Award className="w-6 h-6 sm:w-8 sm:h-8 text-accent" />, title: "Top-Rated Studio", desc: "4.9/5 Client Satisfaction" },
    { icon: <Clock className="w-6 h-6 sm:w-8 sm:h-8 text-accent" />, title: "On-Time Delivery", desc: "No delays, guaranteed" },
    { icon: <ShieldCheck className="w-6 h-6 sm:w-8 sm:h-8 text-accent" />, title: "Transparent Pricing", desc: "Zero hidden costs" },
    { icon: <CheckCircle className="w-6 h-6 sm:w-8 sm:h-8 text-accent" />, title: "8+ Years Experience", desc: "Expert craftsmanship" },
  ];

  return (
    <section className={`border-b py-10 relative z-20 transition-colors duration-500 ${isDark ? 'bg-[#111827] border-gray-700' : 'bg-white border-gray-100'
      }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {items.map((item, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className={`mb-3 p-3 rounded-full ${isDark ? 'bg-white/5' : 'bg-slate-50'}`}>{item.icon}</div>
              <p className={`font-poppins font-semibold text-sm sm:text-base ${isDark ? 'text-white' : 'text-primary'}`}>{item.title}</p>
              <p className={`text-[10px] sm:text-xs mt-1 uppercase tracking-wider ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
